import createIcon from '../../createIcon';

/**
 * @component @name EighteenUpRating
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAxMi41SDEzVjE0SDE0LjVWMTIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC41IDEwSDEzVjExLjVIMTQuNVYxMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSAzSDVDMy45IDMgMyAzLjkgMyA1VjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEwIDE1SDguNVYxMC41SDdWOUgxMFYxNVpNMTYgMTRDMTYgMTQuNTUgMTUuNTUgMTUgMTUgMTVIMTIuNUMxMS45NSAxNSAxMS41IDE0LjU1IDExLjUgMTRWMTBDMTEuNSA5LjQ1IDExLjk1IDkgMTIuNSA5SDE1QzE1LjU1IDkgMTYgOS40NSAxNiAxMFYxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EighteenUpRating = createIcon('EighteenUpRating', [
  ['path', { d: 'M14.5 12.5H13V14H14.5V12.5Z', key: '1kk7uj' }],
  ['path', { d: 'M14.5 10H13V11.5H14.5V10Z', key: '1mff2o' }],
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10 15H8.5V10.5H7V9H10V15ZM16 14C16 14.55 15.55 15 15 15H12.5C11.95 15 11.5 14.55 11.5 14V10C11.5 9.45 11.95 9 12.5 9H15C15.55 9 16 9.45 16 10V14Z',
      key: 'qzz98i',
    },
  ],
]);

export default EighteenUpRating;
